import React, { useMemo } from 'react';
import '../../styles/admin/SalesChart.css';

const SalesChart = ({ invoices }) => {
  const chartData = useMemo(() => {
    const salesByDate = {};

    invoices.forEach(invoice => {
      const date = new Date(invoice.date).toLocaleDateString();
      if (!salesByDate[date]) {
        salesByDate[date] = 0;
      }
      salesByDate[date] += invoice.totalAmount;
    });

    const sortedDates = Object.keys(salesByDate).sort((a, b) => {
      return new Date(a) - new Date(b);
    });

    return sortedDates.map(date => ({
      date,
      amount: salesByDate[date]
    }));
  }, [invoices]);

  const maxAmount = useMemo(() => {
    return Math.max(...chartData.map(d => d.amount), 0);
  }, [chartData]);

  if (chartData.length === 0) {
    return (
      <div className="chart-container">
        <div className="chart-header">
          <h2><i className="fas fa-chart-area"></i> Sales Trend</h2>
        </div>
        <div className="no-chart-data">
          <i className="fas fa-chart-line"></i>
          <p>No sales data available for the selected period</p>
        </div>
      </div>
    );
  }

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h2><i className="fas fa-chart-area"></i> Sales Trend</h2>
        <div className="chart-legend">
          <div className="legend-item">
            <span className="legend-color"></span>
            <span>Daily Sales</span>
          </div>
        </div>
      </div>

      <div className="chart-wrapper">
        <div className="chart-y-axis">
          <span className="y-label">{maxAmount.toFixed(0)}</span>
          <span className="y-label">{(maxAmount * 0.75).toFixed(0)}</span>
          <span className="y-label">{(maxAmount * 0.5).toFixed(0)}</span>
          <span className="y-label">{(maxAmount * 0.25).toFixed(0)}</span>
          <span className="y-label">0</span>
        </div>

        <div className="chart-bars">
          {chartData.map((data, index) => {
            const heightPercentage = maxAmount > 0 ? (data.amount / maxAmount) * 100 : 0;
            return (
              <div key={index} className="bar-wrapper">
                <div className="bar-container" title={`${data.date}: LKR ${data.amount.toFixed(2)}`}>
                  <div 
                    className="bar" 
                    style={{ height: `${heightPercentage}%` }}
                  >
                    <span className="bar-value">
                      {data.amount.toFixed(0)}
                    </span>
                  </div>
                </div>
                <div className="bar-label">{data.date.split('/')[0]}/{data.date.split('/')[1]}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SalesChart;